var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationFood2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.375 9.375C25.9283 9.375 27.1875 8.11581 27.1875 6.5625C27.1875 5.00919 25.9283 3.75 24.375 3.75C22.8217 3.75 21.5625 5.00919 21.5625 6.5625C21.5625 8.11581 22.8217 9.375 24.375 9.375Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5469 41.25H7.26562C6.36 41.25 5.625 40.515 5.625 39.6094V29.7656C5.625 28.86 6.36 28.125 7.26562 28.125H10.5469C11.4525 28.125 12.1875 28.86 12.1875 29.7656V39.6094C12.1875 40.515 11.4525 41.25 10.5469 41.25Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 34.6874H25.8581C26.5687 34.6874 27.2587 34.4586 27.8269 34.0311L31.7906 31.0574C32.7806 30.3149 34.1644 30.4143 35.04 31.288C36.0112 32.2593 36.0112 33.8324 35.04 34.8018L31.6387 38.203C30.7237 39.118 29.5556 39.7443 28.2862 39.9974L23.4787 40.9593C22.5262 41.1486 21.5419 41.1261 20.5987 40.8899L16.2506 39.8061C15.7312 39.6749 15.1969 39.6093 14.6606 39.6093H12.1875",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 34.6875H24.4669C25.8394 34.6875 26.9531 33.5756 26.9531 32.2012V31.7044C26.9531 30.5644 26.1769 29.5706 25.0706 29.295L21.3113 28.3556C20.7 28.2019 20.0719 28.125 19.4419 28.125C17.9213 28.125 16.4325 28.575 15.1688 29.4187L12.1875 31.4062",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 22.5H9.375",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 22.5C37.5 15.2513 31.6237 9.375 24.375 9.375C17.1263 9.375 11.25 15.2513 11.25 22.5",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationFood2);
export default __webpack_public_path__ + "static/media/navigation-food2.0d7af1ea.svg";
export { ForwardRef as ReactComponent };